import { sendFiltersAdapter } from './send-filters.adapter'

export { sendFiltersAdapter }